/** Connexion obtenue avec l'ami : directe (host / STUN) ou via un relais TURN. */

interface StatLike {
  readonly id: string;
  readonly type: string;
  readonly [key: string]: unknown;
}

export function connectionKind(stats: Iterable<StatLike>): 'direct' | 'relay' | null {
  const byId = new Map<string, StatLike>();
  for (const s of stats) byId.set(s.id, s);
  const all = [...byId.values()];
  const transport = all.find((s) => s.type === 'transport' && s['selectedCandidatePairId']);
  const pair =
    (transport && byId.get(String(transport['selectedCandidatePairId']))) ??
    all.find(
      (s) =>
        s.type === 'candidate-pair' &&
        (s['selected'] === true || (s['nominated'] === true && s['state'] === 'succeeded')),
    );
  if (!pair) return null;
  const local = byId.get(String(pair['localCandidateId']));
  const remote = byId.get(String(pair['remoteCandidateId']));
  if (!local || !remote) return null;
  return local['candidateType'] === 'relay' || remote['candidateType'] === 'relay'
    ? 'relay'
    : 'direct';
}
